import { ConfigurationService, IConfigurationService } from "./configuration";
import { EmailService, IEmailService } from "./email";
import { FeedbackService, IFeedbackService } from "./feedback";
import { PotluckService, IPotluckService } from "./potluck";
import { UserService, IUserService } from "./user";

export interface IProvidedService {
  configurationService: IConfigurationService
  emailService: IEmailService
  feedbackService: IFeedbackService
  potluckService: IPotluckService
  userService: IUserService
}

export const initializeService = (): IProvidedService => ({
  configurationService: new ConfigurationService(),
  emailService: new EmailService(),
  feedbackService: new FeedbackService(),
  potluckService: new PotluckService(),
  userService: new UserService(),
})